import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'Home',
        meta: { title: 'Home' },
        visibleIn: ['footerQuickLinks', 'sitemap'],
        ui: { label: 'Home' },
        component: () => import(/* webpackChunkName: "Home" */ '@/views/home/Home'),
    },
    {
        path: '/loyalty',
        name: 'Loyalty',
        meta: { title: 'Loyalty' },
        visibleIn: ['footerQuickLinks', 'sitemap'],
        ui: { label: 'Loyalty' },
        component: () => import(/* webpackChunkName: "Loyalty" */ '@/views/Loyalty'),
    },
    {
        path: '/financial',
        name: 'Financial',
        meta: { title: 'Financial - Solutions' },
        visibleIn: ['footerQuickLinks', 'sitemap'],
        childrenRoutes: ['FinancialCases'],
        ui: { label: 'Financial' },
        component: () => import(/* webpackChunkName: "Financial" */ '@/views/industries/financial/Profile'),
    },
    {
        path: '/financial/cases',
        name: 'FinancialCases',
        meta: { title: 'Cases - Financial - Solutions' },
        visibleIn: ['sitemap'],
        ui: { label: 'Financial Cases' },
        component: () => import(/* webpackChunkName: "FinancialCases" */ '@/views/industries/financial/Cases'),
    },
    {
        path: '/airlines',
        name: 'Airlines',
        meta: { title: 'Airlines - Solutions' },
        visibleIn: ['footerQuickLinks', 'sitemap'],
        childrenRoutes: ['AirlinesCases'],
        ui: { label: 'Airlines' },
        component: () => import(/* webpackChunkName: "Airlines" */ '@/views/industries/airlines/Profile'),
    },
    {
        path: '/airlines/cases',
        name: 'AirlinesCases',
        meta: { title: 'Cases - Airlines - Solutions' },
        visibleIn: ['sitemap'],
        ui: { label: 'Airlines Cases' },
        component: () => import(/* webpackChunkName: "AirlinesCases" */ '@/views/industries/airlines/Cases'),
    },
    {
        path: '/malls',
        name: 'Malls',
        meta: { title: 'Malls - Solutions' },
        visibleIn: ['footerQuickLinks', 'sitemap'],
        childrenRoutes: ['MallsCases'],
        ui: { label: 'Malls' },
        component: () => import(/* webpackChunkName: "Malls" */ '@/views/industries/malls/Profile'),
    },
    {
        path: '/malls/cases',
        name: 'MallsCases',
        meta: { title: 'Cases - Malls - Solutions' },
        visibleIn: ['sitemap'],
        ui: { label: 'Malls Cases' },
        component: () => import(/* webpackChunkName: "MallsCases" */ '@/views/industries/malls/Cases'),
    },
    {
        path: '/hospitality',
        name: 'Hospitality',
        meta: { title: 'Hospitality - Solutions' },
        visibleIn: ['footerQuickLinks', 'sitemap'],
        childrenRoutes: ['HospitalityCases'],
        ui: { label: 'Hospitality' },
        component: () => import(/* webpackChunkName: "Hospitality" */ '@/views/industries/hospitality/Profile'),
    },
    {
        path: '/hospitality/cases',
        name: 'HospitalityCases',
        meta: { title: 'Cases - Hospitality - Solutions' },
        visibleIn: ['sitemap'],
        ui: { label: 'Hospitality Cases' },
        component: () => import(/* webpackChunkName: "HospitalityCases" */ '@/views/industries/hospitality/Cases'),
    },
    {
        path: '/telecom',
        name: 'Telecom',
        meta: { title: 'Telecom - Solutions' },
        visibleIn: ['footerQuickLinks', 'sitemap'],
        ui: { label: 'Telecom' },
        component: () => import(/* webpackChunkName: "Telecom" */ '@/views/industries/telecom/Profile'),
    },
    {
        path: '/technology',
        name: 'TheTechnology',
        meta: { title: 'Technology' },
        visibleIn: ['footerQuickLinks', 'sitemap'],
        ui: { label: 'Technology' },
        component: () => import(/* webpackChunkName: "Technology" */ '@/views/TheTechnology'),
    },
    {
        path: '/security',
        name: 'Compliance',
        meta: { title: 'Security' },
        visibleIn: ['footerQuickLinks', 'sitemap'],
        ui: { label: 'Security' },
        component: () => import(/* webpackChunkName: "Compliance" */ '@/views/Compliance'),
    },
    {
        path: '/clients-and-cases',
        name: 'ClientsAndCases',
        meta: { title: 'Cases' },
        visibleIn: ['footerQuickLinks', 'sitemap'],
        ui: { label: 'Cases' },
        component: () => import(/* webpackChunkName: "ClientsAndCases" */ '@/views/ClientsAndCases'),
    },
    {
        path: '/about',
        name: 'AboutUs',
        meta: { title: 'About us - About' },
        visibleIn: ['footerQuickLinks', 'sitemap'],
        ui: { label: 'About us' },
        component: () => import(/* webpackChunkName: "AboutUs" */ '@/views/about/AboutUs'),
    },
    {
        path: '/contact',
        name: 'Contact',
        meta: { title: 'Contact - About' },
        visibleIn: ['sitemap'],
        ui: { label: 'Contact' },
        component: () => import(/* webpackChunkName: "Contact" */ '@/views/about/Contact'),
    },
    {
        path: '/careers',
        name: 'Careers',
        meta: { title: 'Careers - About' },
        visibleIn: ['footerQuickLinks', 'sitemap'],
        ui: { label: 'Careers' },
        component: () => import(/* webpackChunkName: "Careers" */ '@/views/about/Careers'),
    },
    {
        path: '/copyright',
        name: 'Copyrights',
        meta: { title: 'Copyright' },
        visibleIn: ['sitemap'],
        ui: { label: 'Copyright' },
        component: () => import(/* webpackChunkName: "Copyrights" */ '@/views/Copyrights'),
    },
    {
        path: '/data-protection',
        name: 'DataProtection',
        meta: { title: 'Data Protection - GDPR' },
        visibleIn: ['sitemap'],
        ui: { label: 'Data Protection - GDPR' },
        component: () => import(/* webpackChunkName: "DataProtection" */ '@/views/DataProtection'),
    },
    {
        path: '/use-of-cookies',
        name: 'UseOfCookies',
        meta: { title: 'Use of Cookies' },
        visibleIn: ['sitemap'],
        ui: { label: 'Use of Cookies' },
        component: () => import(/* webpackChunkName: "UseOfCookies" */ '@/views/UseOfCookies'),
    },
    {
        path: '/sitemap',
        name: 'Sitemap',
        meta: { title: 'Sitemap' },
        visibleIn: ['sitemap'],
        ui: { label: 'Sitemap' },
        component: () => import(/* webpackChunkName: "Sitemap" */ '@/views/Sitemap'),
    },
    {
        path: '/news',
        name: 'News',
        meta: { title: 'News' },
        visibleIn: ['footerQuickLinks', 'sitemap'],
        ui: { label: 'News' },
        childrenRoutes: ['NewsProfile'],
        footerDisclaimer: true,
        component: () => import(/* webpackChunkName: "News" */ '@/views/news/News'),
    },
    {
        path: '/news/view/:releaseId',
        name: 'NewsProfile',
        meta: { title: 'View - News' },
        component: () => import(/* webpackChunkName: "NewsProfile" */ '@/views/news/Profile'),
    },
    {
        path: '/reports-and-presentations/',
        name: 'ReportsAndPresentations',
        meta: { title: 'Reports & Presentations - Investor' },
        visibleIn: ['footerQuickLinks', 'sitemap'],
        ui: { label: 'Reports & Presentations' },
        footerDisclaimer: true,
        component: () => import(/* webpackChunkName: "ReportAndPresentations" */ '@/views/investor/ReportsAndPresentations'),
    },
    {
        path: '/investor-relations-contact/',
        name: 'InvestorRelationsContact',
        meta: { title: 'IR Contact - Investor' },
        visibleIn: ['footerQuickLinks', 'sitemap'],
        ui: { label: 'IR Contact' },
        props: true,
        component: () => import(/* webpackChunkName: "InvestorRelationsContact" */ '@/views/investor/InvestorRelationsContact'),
    },
    {
        path: '/nasdaq-stockholm-first-north/',
        name: 'Nasdaq',
        meta: { title: 'Nasdaq Stockholm First North - Investor' },
        visibleIn: ['footerQuickLinks', 'sitemap'],
        ui: { label: 'Nasdaq' },
        component: () => import(/* webpackChunkName: "Nasdaq" */ '@/views/investor/Nasdaq'),
    },
    {
        path: '/ipo/',
        name: 'Ipo',
        meta: { title: 'IPO - Investor' },
        visibleIn: ['footerQuickLinks', 'sitemap'],
        ui: { label: 'IPO' },
        component: () => import(/* webpackChunkName: "Ipo" */ '@/views/investor/Ipo'),
    },
    {
        path: '/corporate-governance/',
        name: 'CorporateGovernance',
        meta: { title: 'Corporate Governance - Investor' },
        visibleIn: ['footerQuickLinks', 'sitemap'],
        ui: { label: 'Corporate Governance' },
        component: () => import(/* webpackChunkName: "CorporateGovernance" */ '@/views/investor/CorporateGovernance'),
    },
    {
        path: '/ownership/',
        name: 'Ownership',
        meta: { title: 'Ownership - Investor' },
        visibleIn: ['footerQuickLinks', 'sitemap'],
        ui: { label: 'Ownership' },
        component: () => import(/* webpackChunkName: "Ownership" */ '@/views/investor/ownership/Ownership'),
    },
    {
        path: '/shares/',
        name: 'Shares',
        redirect: { name: 'SharesPerformance' },
        meta: { title: 'Shares - Investor' },
        visibleIn: ['footerQuickLinks', 'sitemap'],
        childrenRoutes: ['SharesPerformance', 'SharesOrderBook', 'SharesTrades', 'SharesCalculator'],
        ui: { label: 'Shares' },
        component: () => import(/* webpackChunkName: "Shares" */ '@/views/investor/shares/Shares'),
        children: [
            {
                name: 'SharesPerformance',
                path: '',
                meta: { title: 'Performance - Shares - Investor' },
                footerDisclaimer: true,
                component: () => import(/* webpackChunkName: "SharesPerformance" */ '@/views/investor/shares/children/Performance'),
            },
            {
                name: 'SharesOrderBook',
                path: 'order-book/',
                meta: { title: 'Order book - Shares - Investor' },
                footerDisclaimer: true,
                component: () => import(/* webpackChunkName: "SharesOrderBook" */ '@/views/investor/shares/children/OrderBook'),
            },
            {
                name: 'SharesTrades',
                path: 'trades/',
                meta: { title: 'Trades - Shares - Investor' },
                footerDisclaimer: true,
                component: () => import(/* webpackChunkName: "SharesTrades" */ '@/views/investor/shares/children/Trades'),
            },
            {
                name: 'SharesCalculator',
                path: 'calculator/',
                meta: { title: 'Calculator - Shares - Investor' },
                footerDisclaimer: true,
                component: () => import(/* webpackChunkName: "SharesCalculator" */ '@/views/investor/shares/children/calculator/Calculator'),
            },
        ]
    },
    {
        path: '/certified-adviser/',
        name: 'CertifiedAdviser',
        meta: { title: 'Certified Adviser - Investor' },
        visibleIn: ['footerQuickLinks', 'sitemap'],
        ui: { label: 'Certified Adviser' },
        component: () => import(/* webpackChunkName: "CertifiedAdviser" */ '@/views/investor/CertifiedAdviser'),
    },
    {
        path: '/financial-calendar/',
        name: 'FinancialCalendar',
        meta: { title: 'Financial Calendar - Investor' },
        visibleIn: ['footerQuickLinks', 'sitemap'],
        childrenRoutes: ['FinancialCalendarProfile'],
        ui: { label: 'Financial Calendar' },
        footerDisclaimer: true,
        component: () => import(/* webpackChunkName: "FinancialCalendar" */ '@/views/investor/calendar/Calendar'),
    },
    {
        path: '/financial-calendar/view/:eventGuid',
        name: 'FinancialCalendarProfile',
        meta: { title: 'View Upcoming Event - Financial Calendar - Investor' },
        footerDisclaimer: true,
        component: () => import(/* webpackChunkName: "FinancialCalendarProfile" */ '@/views/investor/calendar/CalendarProfile'),
    },
    {
        path: '/404',
        name: 'PageNotFound',
        meta: { title: '404 - Page Not Found', noIndex: true, },
        component: () => import(/* webpackChunkName: "NotFound" */ '@/views/NotFound404'),
    },
    {
        path: '*',
        redirect: '/404',
    },

    // Changed routes
    {
        path: '/compliance',
        redirect: { name: 'Compliance' },
    },
    {
        path: '/the-sitemap',
        redirect: { name: 'Sitemap' },
    },
    {
        path: '/copyrights',
        redirect: { name: 'Copyrights' },
    },

    // Old LS site paths redirects
    {
        path: '/category/cases',
        redirect: { name: 'ClientsAndCases' },
    },
    {
        path: '/klub-nordjyske',
        redirect: { name: 'ClientsAndCases' },
    },
    {
        path: '/case-associations',
        redirect: { name: 'ClientsAndCases' },
    },
    {
        path: '/citywide-loyalty',
        redirect: { name: 'ClientsAndCases' },
    },
    {
        path: '/mortimer-harvey',
        redirect: { name: 'ClientsAndCases' },
    },
    {
        path: '/case-retail',
        redirect: { name: 'ClientsAndCases' },
    },
    {
        path: '/randers-fc',
        redirect: { name: 'ClientsAndCases' },
    },
    {
        path: '/case-b2b',
        redirect: { name: 'ClientsAndCases' },
    },
    {
        path: '/da/category/cases-da',
        redirect: { name: 'ClientsAndCases' }
    },
    {
        path: '/da/flyselskaber',
        redirect: { name: 'Airlines' },
    },
    {
        path: '/case-eurobonus',
        redirect: { name: 'AirlinesCases' },
    },
    {
        path: '/da/tele',
        redirect: { name: 'Telecom' },
    },
    {
        path: '/da/finansielle-sektor',
        redirect: { name: 'Financial' }
    },
    {
        path: '/financial-industry',
        redirect: { name: 'Financial' }
    },
    {
        path: '/da/medier',
        redirect: { name: 'Media' }
    },
    {
        path: '/da/category/industries-da',
        redirect: { name: 'Home', hash: '' }
    },
    {
        path: '/da',
        redirect: { name: 'Home' }
    },
    {
        path: '/da/kom-godt-i-gang',
        redirect: { name: 'Loyalty' }
    },
    {
        path: '/getting-started',
        redirect: { name: 'Loyalty' }
    },
    {
        path: '/da/loyaltfacts-da',
        redirect: { name: 'TheTechnology' }
    },
    {
        path: '/loyaltfacts',
        redirect: { name: 'TheTechnology' }
    },
    {
        path: '/da/om-os',
        redirect: { name: 'AboutUs' }
    },
    {
        path: '/da/kontakt-os',
        redirect: { name: 'Contact' }
    },
    {
        path: '/contact-us',
        redirect: { name: 'Contact' }
    },
    {
        path: '/da/use-of-cookies-da',
        redirect: { name: 'UseOfCookies' }
    },
    {
        path: '/da/databeskyttelsesforordningen-gdpr',
        redirect: { name: 'DataProtection' }
    },
    {
        path: '/data-protection-gdpr',
        redirect: { name: 'DataProtection' }
    },
    {
        path: '/da/copyright',
        redirect: { name: 'Copyrights' }
    },
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});

router.beforeEach((to, from, next) => {
    const excludedRoutes = [
        'News',
        'ReportsAndPresentations',
        'FinancialCalendar',
        'SharesPerformance',
        'SharesOrderBook',
        'SharesTrades',
        'SharesCalculator',
        'LargestShareHolders',
        'LargestGroupedShareHolders',
        'OwnershipShareRanges',
        'OwnershipGeographicalDistribution',
    ];

    if (!excludedRoutes.includes(to.name)) {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }

    next();
});

export default router
